import {
  type CreateTenantInput,
  type DeleteTenantInput,
  TenantResponseSchema,
  type UpdateTenantInput,
} from '@disparos/contracts';
import { z } from 'zod';
import { apiFetch } from './client';

const VoidSchema = z.void();
const UpdateNameResponseSchema = z.object({ name: z.string() });

export async function createTenant(input: CreateTenantInput) {
  return apiFetch('/account/tenants', TenantResponseSchema, {
    method: 'POST',
    body: input,
  });
}

export async function updateCurrentTenant(input: UpdateTenantInput) {
  return apiFetch('/account/tenant', UpdateNameResponseSchema, {
    method: 'PATCH',
    body: input,
  });
}

export async function deleteCurrentTenant(input: DeleteTenantInput) {
  return apiFetch('/account/tenant', VoidSchema, {
    method: 'DELETE',
    body: input,
  });
}
